"use client";

import { useState } from "react";

const faqs = [
  {
    question: "Do I need my own brokerage account?",
    answer: "No. The Stratos Engine natively handles all execution routing through our institutional prime brokerage partners. You simply fund your account and assign capital to your chosen algorithmic nodes."
  },
  {
    question: "Can I cancel or pause my subscription at any time?",
    answer: "Absolutely. You can downgrade to the free Observer tier at any moment from your dashboard. If you pause, all live execution halts immediately and your capital is returned to cash."
  },
  {
    question: "How does the Stratos-VX (VIX Hedge) work?",
    answer: "The Omni tier grants access to Stratos-VX. When our macro-regime indicators detect severe volatility spikes, this node automatically deploys capital into VIX derivatives to explicitly short the market, defending your portfolio from drawdowns."
  },
  {
    question: "Is my capital locked up for a specific timeframe?",
    answer: "Never. Unlike traditional hedge funds, Stratos imposes zero lock-up periods. You retain complete liquidity and can withdraw your cash balance on any standard trading day."
  },
  {
    question: "What is the difference between Alpha and Omni?",
    answer: "Alpha limits you to running 2 algorithms simultaneously without Webhook access. Omni is our institutional tier, unlocking all 6 mathematical strategies, priority engineering support, and full sub-second API Webhooks for custom integrations."
  }
];

export default function FaqAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-3xl w-full mt-32 mx-auto">
      <h2 className="text-3xl font-bold text-center mb-12">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`border rounded-2xl transition-all duration-300 ${
              openIndex === index ? "bg-slate-900/80 border-emerald-500/30 shadow-[0_0_20px_rgba(16,185,129,0.1)]" : "bg-slate-900/40 border-white/10 hover:border-white/20"
            }`}
          >
            <button 
              onClick={() => toggleFaq(index)}
              className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
            >
              <span className="font-semibold text-lg text-slate-200">{faq.question}</span>
              <span className={`text-emerald-400 transform transition-transform duration-300 text-2xl ${openIndex === index ? "rotate-45" : ""}`}>
                +
              </span>
            </button>
            <div 
              className={`overflow-hidden transition-all duration-300 ${openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"}`}
            >
              <div className="p-6 pt-0 text-slate-400 leading-relaxed">
                {faq.answer}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
